<template>
<div class="video-container">
    <component
        v-model="content"
        :video="content"
        :is="typeVideo"
        @progress="$emit('progress', $event)"
        @input="showChat"
        @liveSettings="$emit('liveSettings', $event)"
    />
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import OD from './ContentVideo/ContentOnDemand';
import LV from './ContentVideo/ContentLive';
import VC from './ContentVideo/ContentConference';
import TabOptions from '../../Common/TabOptions/TabOptions';

export default {
    name: 'ClassContentVideo',
    components: {
        OD,
        LV,
        VC,
        TabOptions,
    },

    data() {
        return {
            // tab: null,
            files: [],
        };
    },

    props: {
        rightBar: Boolean,
    },

    computed: {
        ...mapGetters({
            language: 'LANGUAGE',
            content: 'CLASS_CONTENT',
        }),

        typeVideo() {
            const type = this.content.type_video;
            if (type === 'OD') return 'OD';
            else if (type === 'NCH_VC') return 'VC';
            return 'LV';
        },
    },

    methods: {
        showChat(video) {
            // chat é exibido quando ao vivo ou configurado para exibir pós live (ondemand)
            const value = video && video.settings && video.settings.chat
                && (video.settings.chat_show || video.settings.live);

            // emite valor alterado para sidebar
            this.$emit('side', { value: !!value, data: video.settings });
        },
        // changeTab() {
        //     const data = this.tab == 3
        //         ? { value: this.showChat, data: this.video.settings }
        //         : { value: false, data: this.video.settings };

        //     this.$emit('side', data);
        // },
    },

    beforeMount() {
        const chat = document.getElementById('support-chat');
        if (chat) {
            chat.style.display = 'none';
        }
    },
};
</script>

<style lang="sass" scoped>
.video-container
    height: 80%
</style>
